import { useEffect, useState } from 'react';

import CommonDayInfo from '@/components/quartered-forecast/CommonDayInfo';
import ExtraDayInfo from '@/components/quartered-forecast/ExtraDayInfo';
import QuarterDayInfo from '@/components/quartered-forecast/QuarterDayInfo';
import { QuarteredForecast } from '@/models/QuarteredForecast';

type DayInfoProps = {
  dayInfo: QuarteredForecast;
  openByDefault: boolean;
};

const DayInfo = ({ dayInfo, openByDefault }: DayInfoProps) => {
  const [isOpen, setIsOpen] = useState(openByDefault);

  useEffect(() => {
    if (openByDefault) {
      setIsOpen(openByDefault);
    }
  }, [openByDefault]);

  const { dayOfWeek, date, temperatureHigh, temperatureLow, icon, description, magneticField, waterTemperature } =
    dayInfo;

  return (
    <details
      className="group border-b border-blue-grey-200 px-4 py-2 first-of-type:pt-0 lg:px-0 lg:py-3 lg:first-of-type:pt-3 lg:hover:bg-blue-300/10"
      open={openByDefault}
    >
      <summary className="cursor-pointer list-none" onClick={() => setIsOpen(!isOpen)}>
        <CommonDayInfo {...{ dayOfWeek, date, temperatureHigh, temperatureLow, icon, description, open: isOpen }} />
      </summary>
      <div className="mt-1.5 mb-3 hidden justify-end border-b border-blue-grey-200 pb-1.5 text-sm font-medium text-blue-grey-500 lg:flex xl:mx-6 xl:mb-4 xl:mt-2.5">
        <div className="mr-6 basis-[90px] xl:mr-10">
          Ощущается <br /> как
        </div>
        <div className="flex basis-[59%] xl:basis-[47%]">
          <div className="basis-1/4">Осадки</div>
          <div className="basis-1/4">Влажность</div>
          <div className="basis-1/4">
            Давление,
            <br />
            мм. рт. ст.
          </div>
          <div className="basis-1/4">
            Ветер, <br /> м/с
          </div>
        </div>
      </div>
      <div className="xl:mx-6">
        {dayInfo.night && <QuarterDayInfo quarterInfo={dayInfo.night} quarterName="Ночь" />}
        {dayInfo.morning && <QuarterDayInfo quarterInfo={dayInfo.morning} quarterName="Утро" />}
        {dayInfo.day && <QuarterDayInfo quarterInfo={dayInfo.day} quarterName="День" />}
        {dayInfo.evening && <QuarterDayInfo quarterInfo={dayInfo.evening} quarterName="Вечер" />}

        <ExtraDayInfo {...{ magneticField, waterTemperature }} />
      </div>
    </details>
  );
};

export default DayInfo;
